"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireWildcard(require("react"));
var InputParts = _interopRequireWildcard(require("./InputParts"));
var _SecondaryIconButton = _interopRequireDefault(require("../Buttons/SecondaryIconButton"));
var _Search = _interopRequireWildcard(require("./Search"));
var _helpers = require("../helpers");
var _excluded = ["width"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "SearchWithButton__Wrapper",
  componentId: "sc-we7ly4-0"
})(["width:", ";display:flex;"], function (props) {
  return props.width || "100%";
});
var CustomBorderInput = (0, _styledComponents["default"])(InputParts.StyledInput).withConfig({
  displayName: "SearchWithButton__CustomBorderInput",
  componentId: "sc-we7ly4-1"
})(["border-color:", ";&:focus{border-color:", ";}"], function (props) {
  return (0, _helpers.getColor)(props, "backgroundColor", "backgroundPrimary");
}, function (props) {
  return props.theme.colors.border;
});
var SearchWithButton = function SearchWithButton(_ref) {
  var width = _ref.width,
    other = _objectWithoutProperties(_ref, _excluded);
  var inputRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    width: width
  }, /*#__PURE__*/_react["default"].createElement(_Search["default"], _extends({
    forwardedRef: inputRef,
    component: CustomBorderInput,
    glued: "right"
  }, other)), /*#__PURE__*/_react["default"].createElement(_SecondaryIconButton["default"], {
    name: "search",
    glued: "left",
    onClick: function onClick() {
      return other.onSearch(inputRef.current.value);
    }
  }));
};
SearchWithButton.propTypes = _Search.searchPropTypes;
SearchWithButton.defaultProps = {
  variant: null
};
var _default = SearchWithButton;
exports["default"] = _default;